export function toOUI(macAddress: string) {
  return macAddress.substring(0, 8).toUpperCase();
}

export function isOUI(oui: string): boolean {
  const regex = /^([0-9A-Fa-f]{2}[:-]){2}([0-9A-Fa-f]{2})$/; // 00:00:5e, 00-00-5e
  return regex.test(oui);
}

export function isMACAddress(macAddress: string): boolean {
  const regex1 = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/; // 00:00:5e:00:53:01, 00-00-5e-00-53-01
  const regex2 = /^([0-9A-Fa-f]{4}\.){2}([0-9A-Fa-f]{4})$/; // 0000.5e00.5301
  return regex1.test(macAddress) || regex2.test(macAddress);
}
